<template>
  <div class="explore has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold is-hidden-mobile">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-uppercase" style="font-weight: 900;">
            {{ $t('general.explore') }}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-light">
            {{ $t('msgs.explorehero3') }}
          </h2>
        </div>
      </div>
    </section>

    <section class="section py-5 has-background-white-ter is-bold is-hidden-tablet">
      <div class="container">
        <h1 class="title is-4 is-uppercase" style="font-weight: 900;">
          {{ $t('general.explore') }}
        </h1>
      </div>
    </section>

    <section class="section">
      <div class="container" v-if="loadingRecently">
        <div class="columns is-variable is-1-mobile is-mobile is-multiline">
          <div class="column is-one-third-desktop is-one-third-tablet is-half-mobile"
            v-for="i in ske" :key="i">
            <div class="media-content">
              <figure class="image is-16by9 skeleton">
                <div class="skeleton-block"></div>
              </figure>
              <div class="pt-1"><b-skeleton></b-skeleton></div>
              <b-skeleton width="30%"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="!loadingRecently">
        <div class="columns is-variable is-1-mobile is-mobile is-multiline">
          <div class="column is-one-third-desktop is-one-third-tablet is-half-mobile"
            v-for="item in list" :key="item.id">
            <router-link :to='"/video/" + item.id' :title="item.title">
              <video-item
                :channel-title="item.channel.title"
                :youtube-id="item.provider_video_id"
                :title="item.title">
              </video-item>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container has-text-centered">
        <infinite-loading
          v-if="isFirstPageFinished"
          spinner="waveDots"
          @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>

  </div>
</template>

<script>
import { getVideos } from '@/api/api';

export default {
  name: 'Explore',

  metaInfo() {
    return {
      title: this.$t('title.explore'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.explore') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      loadingRecently: true,
      ske: 12,
      limit: 12,
      list: [],
      page: 1,
      lastPage: 1,
      isEmpty: false,
      isFirstPageFinished: false,
    };
  },

  created() {
    this.fetchData();
  },

  mounted() {
    this.forGtag();
  },

  methods: {
    fetchData() {
      getVideos({ params: { limit: this.limit, page: this.page } })
        .then((result) => {
          const { data, total, last_page: lastPage } = result.data;
          this.total = total;
          this.lastPage = lastPage;
          this.list = data;

          this.loadingRecently = false;

          if (data.length === 0) {
            this.isEmpty = true;
          } else {
            this.page += 1;
          }

          this.isFirstPageFinished = true;
        })
        .catch((err) => { console.error(err); });
    },

    setFallbackImageUrl(event) {
      const id = event.path[0].parentElement.getAttribute('vt-id');
      const image = event.path[0];

      if (image.naturalWidth === 120) {
        image.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
      }
    },

    infiniteHandler($state) {
      if (this.page + 1 > this.lastPage) {
        $state.complete();
        return;
      }

      getVideos({ params: { limit: this.limit, page: this.page } })
        .then((result) => {
          const { data } = result.data;

          if (data.length > 0) {
            this.page += 1;
            this.list.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        }).catch((err) => { console.error(err); });
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.explore'));
      }, 100);
    },
  },
};
</script>
